<template>
  <div class="el-storefront__modal" v-bind:class="{'_active': cartOpenned}">
    <div id="backgroundModal" class="el-storefront__modal__background"></div>
    <div class="el-storefront__modal__main" ref="modalMain" v-click-outside="clickedOutside">
      <div class="el-storefront__modal__header">
        <div class="eu-flex eu-align-items_center">
          <div class="eu-flex-item">
            <p class="emd-text _size_page">
              <span class="emd-text _color_primary eu-mr_2">
                <i
                  class="uil uil-shopping-cart"
                  v-if="selectedSection.key === 'cart'"
                />
                <i
                  class="uil uil-map-marker-alt"
                  v-if="selectedSection.key === 'shipping'"
                />
              </span>
              {{ title }}
            </p>
          </div>
          <div class="eu-flex-item eu-shrink_1">
            <button class="emd-btn _type_link _size_big closeCartBtn" @click="closeCart">
              <i class="uil uil-times" />
            </button>
          </div>
        </div>
        <div class="eu-mt_5" v-if="cart.length">
          <emd-progress-indicator
            :items="sections"
            :interactive="true"
            variant="primary"
            @goTo="goToState"
          />
        </div>
      </div>
      <hr class="emd-divider" />

      <div class="el-storefront__modal__content">
        <div v-if="creatingCheckout" class="eu-align_center">
          <svg
            class="circular-loader"
            version="1.1"
            id="L9"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 100 100"
            enable-background="new 0 0 0 0"
            xml:space="preserve"
          >
            <path
              fill="#9399a1"
              d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"
              transform="rotate(184.322 50 50)"
            >
              <animateTransform
                attributeName="transform"
                attributeType="XML"
                type="rotate"
                dur="1s"
                from="0 50 50"
                to="360 50 50"
                repeatCount="indefinite"
              />
            </path>
          </svg>
          <p
            class="emd-text _color_nonessential _size_section eu-align_center eu-mt_3"
          >Você está sendo redirecionado para um ambiente seguro.</p>
        </div>

        <div v-else>
          <emd-alert
            :variant="formError ? 'danger' : 'success'"
            v-if="showAlert"
            @cancel="showAlert = false"
            :title="formError ? 'Erro' :  'Sucesso'"
          >
            <template slot="content">
              <div v-if="formError">
                <p v-for="(error, index) in errors" :key="index" v-html="error"></p>
              </div>
            </template>
          </emd-alert>
          <template v-if="selectedSection.key === 'cart'">
            <div v-if="cart.length === 0" class="eu-align_center">
              <div class="eu-mb_3">
                <svg
                  width="173"
                  height="167"
                  viewBox="0 0 173 167"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M33.4623 43.3653C16.4055 67.5746 22.7161 97.6204 36.3042 119.689C60.4056 158.55 133.717 146.513 150.942 117.244C168.167 87.9747 146.881 49.9948 129.944 32.4153C113.007 14.8358 50.5191 19.1561 33.4623 43.3653Z"
                    fill="#F4F7F9"
                  />
                  <path
                    d="M66.3714 118.088C61.768 119.758 56.5995 117.391 54.5906 115.999L28.0599 114.453C20.9932 114.968 8.69868e-06 117.172 0 111.115C-5.47382e-06 107.304 17.8637 105.559 22.7599 105.065L58.6485 72.6589C68.4914 64.1788 93.2652 50.4291 124.52 61.4531C163.589 75.2331 168.529 98.3214 163.543 115.999C160.59 126.47 151.278 136.549 130.88 138.221C110.483 139.893 100.746 133.981 90.7515 131.407C80.3688 128.732 90.1738 127.196 94.9915 126.864C103.774 126.258 120.583 132.315 137.089 126.258C153.594 120.201 152.534 111.122 151.777 110.062C151.02 109.002 148.294 109.608 140.572 112.485C132.849 115.362 105.894 117.179 102.411 113.393C98.9286 109.608 104.229 106.125 104.38 106.125H90.7515C88.7829 106.125 72.1257 115.999 66.3714 118.088Z"
                    fill="#E7E9F0"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M31.8181 48.883C30.1785 49.4092 28.3955 50.0913 27.2562 50.5585C26.8693 50.7171 26.4271 50.5321 26.2684 50.1452C26.1098 49.7583 26.2948 49.316 26.6817 49.1574C27.8459 48.68 29.6675 47.9829 31.3553 47.4411C32.198 47.1707 33.0219 46.9342 33.7208 46.7841C34.0699 46.7091 34.4012 46.6528 34.6958 46.6264C34.976 46.6012 35.2843 46.5968 35.5578 46.6656C35.8719 46.7445 36.1125 46.9483 36.2501 47.2188C36.3709 47.4565 36.3941 47.7072 36.3913 47.9032C36.3857 48.2943 36.2689 48.7532 36.1235 49.2014C35.8353 50.0897 35.3345 51.226 34.8429 52.3413C34.8274 52.3762 34.812 52.4112 34.7966 52.4461C34.2792 53.6202 33.7747 54.7725 33.4709 55.7025C33.3181 56.1703 33.231 56.5384 33.208 56.8008C33.2033 56.8548 33.2018 56.898 33.202 56.9319C33.2066 56.9317 33.2113 56.9314 33.2162 56.9312C33.3701 56.9224 33.6046 56.8668 33.9292 56.7409C34.5753 56.4902 35.3797 56.042 36.2595 55.5254C36.4558 55.4102 36.6558 55.2915 36.8573 55.172C37.5341 54.7706 38.228 54.359 38.8572 54.0305C39.2684 53.8158 39.6741 53.6246 40.0508 53.4887C40.4149 53.3574 40.816 53.2536 41.198 53.2708C41.6158 53.2896 41.9392 53.6435 41.9204 54.0612C41.9016 54.4789 41.5477 54.8023 41.1299 54.7835C41.0427 54.7796 40.8628 54.8057 40.5646 54.9132C40.279 55.0162 39.9411 55.1728 39.558 55.3728C38.9689 55.6804 38.3252 56.0622 37.6559 56.4591C37.4482 56.5823 37.238 56.7069 37.0262 56.8313C36.1564 57.342 35.2528 57.8516 34.477 58.1526C34.0907 58.3025 33.6858 58.4212 33.3023 58.443C32.9157 58.465 32.4503 58.3913 32.0897 58.0352C31.6808 57.6313 31.6657 57.0557 31.6995 56.6689C31.7374 56.2348 31.8663 55.7378 32.0314 55.2323C32.3634 54.2159 32.9025 52.9891 33.411 51.8354L33.4331 51.7852C33.9444 50.6252 34.4191 49.5479 34.6831 48.7342C34.764 48.4848 34.8162 48.2858 34.8459 48.1333C34.841 48.1337 34.8361 48.1342 34.8311 48.1346C34.6196 48.1536 34.3536 48.197 34.0388 48.2646C33.4097 48.3997 32.6393 48.6194 31.8181 48.883ZM34.8753 47.837C34.8754 47.837 34.8755 47.8376 34.8757 47.8391C34.8754 47.8377 34.8753 47.837 34.8753 47.837ZM33.1062 56.9259C33.1063 56.9258 33.108 56.9262 33.1109 56.9274C33.1076 56.9266 33.1061 56.926 33.1062 56.9259Z"
                    fill="#E7E9F0"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M41.7037 35.4191C40.4405 35.501 39.0452 35.6685 38.148 35.798C37.7341 35.8577 37.3502 35.5706 37.2904 35.1568C37.2307 34.7429 37.5178 34.359 37.9317 34.2992C38.8554 34.1659 40.2919 33.9931 41.6057 33.9079C42.2613 33.8654 42.9017 33.8437 43.439 33.8621C43.7073 33.8713 43.9635 33.891 44.1902 33.9267C44.4026 33.9602 44.6505 34.0166 44.8636 34.1308C45.1269 34.272 45.2974 34.51 45.3596 34.782C45.4136 35.0182 45.3773 35.2376 45.3361 35.3928C45.2537 35.7023 45.0738 36.0312 44.8871 36.3293C44.5154 36.9229 43.9467 37.6541 43.397 38.3609C43.3783 38.3849 43.3597 38.4089 43.3411 38.4328C42.7572 39.1836 42.1951 39.9104 41.8164 40.5124C41.6787 40.7313 41.5783 40.9136 41.5119 41.0593C41.5827 41.0568 41.6671 41.0502 41.7665 41.0378C42.2566 40.9766 42.8993 40.8046 43.6243 40.5921C43.7835 40.5454 43.9467 40.4968 44.1117 40.4477C44.67 40.2813 45.2488 40.1089 45.7646 39.9852C46.102 39.9043 46.4368 39.838 46.7439 39.8071C47.0375 39.7776 47.3742 39.7724 47.6818 39.8645C48.0824 39.9844 48.31 40.4063 48.1901 40.8069C48.0702 41.2075 47.6482 41.4351 47.2476 41.3152C47.2227 41.3077 47.1196 41.2912 46.8955 41.3138C46.6849 41.335 46.4242 41.3843 46.1177 41.4578C45.6458 41.5709 45.123 41.7266 44.5732 41.8903C44.4012 41.9416 44.2266 41.9936 44.0502 42.0453C43.3363 42.2545 42.5824 42.4619 41.9542 42.5404C41.6418 42.5794 41.3066 42.5942 40.9984 42.5353C40.687 42.4758 40.3051 42.3192 40.0708 41.9334C39.8012 41.4896 39.9218 40.9974 40.0189 40.7167C40.1315 40.3911 40.3227 40.0431 40.5347 39.7061C40.9618 39.0272 41.5756 38.2364 42.1457 37.5033L42.1648 37.4787C42.7445 36.7332 43.2736 36.0527 43.6038 35.5255C43.6337 35.4778 43.6606 35.4333 43.6849 35.3919C43.5952 35.3848 43.4959 35.3792 43.3871 35.3755C42.9212 35.3595 42.3368 35.378 41.7037 35.4191ZM43.8755 34.9909C43.8756 34.9908 43.8753 34.9926 43.8745 34.9962C43.875 34.9928 43.8754 34.9909 43.8755 34.9909ZM41.4197 41.3292C41.4195 41.3293 41.4195 41.326 41.4206 41.3187C41.4205 41.3254 41.42 41.329 41.4197 41.3292Z"
                    fill="#E7E9F0"
                  />
                  <path
                    d="M60.6751 79.475C55.5871 73.9024 49.0656 75.9417 46.4408 77.6579C46.4408 83.7151 60.6751 111.578 62.4922 113.092C64.3094 114.606 79.7551 116.726 80.9666 113.092C82.178 109.458 67.0351 86.4407 60.6751 79.475Z"
                    fill="#D5D6DF"
                  />
                  <path
                    d="M11.0064 81.2921C13.4293 76.9309 20.6979 79.4749 24.0293 81.2921C27.9664 88.0559 35.4773 104.309 34.0236 115.212C32.2065 128.841 11.0064 133.384 12.5207 126.721C14.035 120.058 7.97783 86.7435 11.0064 81.2921Z"
                    fill="#D5D6DF"
                  />
                  <path
                    d="M57.0889 95.2154C55.5746 79.7696 41.946 70.3812 31.346 75.8326C20.7459 80.9812 17.4145 91.5812 24.0774 104.907C30.7403 118.233 49.5174 127.318 62.8432 124.29C76.1689 121.261 58.4291 108.886 57.0889 95.2154Z"
                    fill="#DCDEE7"
                  />
                  <path
                    d="M63.4489 122.321C66.1746 121.413 66.1746 115.81 63.4489 115.053C60.5717 114.295 53.1517 117.021 53.9088 119.595C54.666 122.17 60.7232 123.23 63.4489 122.321Z"
                    fill="#B6B7C2"
                  />
                </svg>
              </div>
              <p
                class="emd-text _color_nonessential _size_section eu-align_center"
              >Seu carrinho está vazio, comece a adicionar produtos!</p>
            </div>
            <emd-list-item
              v-for="item in cart"
              :key="item.id"
              :item="item"
              @updateQuantity="updateQuantity"
              @removeItem="openDialog"
            />
          </template>
          <template v-if="selectedSection.key === 'shipping'">
            <app-shipping @next="goNextState" />
          </template>
          <template v-if="selectedSection.key === 'checkout'">
            <app-checkout :items="cart" :shipping="shipping" />
          </template>
        </div>
      </div>
      <hr class="emd-divider" />
      <div class="el-storefront__modal__footer">
        <div class="eu-flex eu-justify_space-between eu-justify_end_md eu-mb_4">
          <div
            class="eu-flex-item eu-basis_6 eu-basis_auto_md eu-shrink_1"
            v-if="showShippingAddress"
          >
            <p class="emd-text _color_subtle">Taxa de entrega:</p>
          </div>
          <div
            class="eu-flex-item eu-basis_6 eu-basis_auto_md eu-shrink_1"
            v-if="showShippingAddress"
          >
            <p
              class="emd-text _type_caption _color_subtle eu-align_right"
            >R$ {{ deliveryCost | currency }}</p>
          </div>
          <div class="eu-flex-divider"></div>
          <div class="eu-flex-item eu-basis_6 eu-basis_auto_md eu-shrink_1" v-if="cart.length">
            <p class="emd-text _color_subtle">Total:</p>
          </div>
          <div class="eu-flex-item eu-basis_6 eu-basis_auto_md eu-shrink_1" v-if="cart.length">
            <p
              class="emd-text _type_caption _color_subtle eu-align_right"
            >R$ {{ totalAmount === 0 ? '-' : totalAmount + deliveryCost | currency }}</p>
          </div>
        </div>
        <div class="eu-align_center eu-align_right_md" v-if="cart.length">
          <button
            type="button"
            class="emd-btn _color_primary _size_big"
            :disabled="cart.length === 0 || creatingCheckout"
            @click="goNextState"
          >
            Continuar
            <i class="uil uil-angle-right" />
          </button>
        </div>
      </div>
      <div class="emd-modal _size_small" :class="{ '_active': modalIsOpen }">
        <div class="emd-modal__content eu-ma_3">
          <div class="emd-container _footer_end eu-grow_1">
            <div class="emd-container__content">
              <div class="el-chunk">
                <h2 class="emd-text _size_section _color_contrast">Remover item?</h2>
              </div>
              <p v-if="itemToRemove" class="emd-text">{{ itemToRemove.name }}</p>
            </div>
            <div class="emd-container__footer">
              <button class="emd-btn _color_primary _type_text" @click="closeDialog()">Cancelar</button>
              <button class="emd-btn _color_danger" @click="removeItem()">Remover</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.circular-loader {
  width: 100px;
  height: 100px;
  margin: 20px;
  display: inline-block;
}

.el-storefront__modal._active > .el-storefront__modal__main {
  z-index: 9;
  height: 100%;
}

.emd-clear-input {
  min-width: 30px;
}

</style>

<script>
import EmdListItem from '@/components/emerald/organisms/EmdListItem'
import EmdProgressIndicator from '@/components/emerald/molecules/EmdProgressIndicator'
import EmdAlert from '@/components/emerald/molecules/EmdAlert.vue'
import AppShipping from './AppShipping'
import AppCheckout from './AppCheckout'

export default {
  name: 'AppModal',
  components: {
    EmdListItem,
    EmdProgressIndicator,
    AppShipping,
    AppCheckout,
    EmdAlert
  },
  props: {
    cartOpenned: Boolean
  },
  data () {
    return {
      modalIsOpen: false,
      itemToRemove: null,
      nextState: 'shipping',
      creatingCheckout: false,
      errors: [],
      showAlert: false,
      formError: false,
      sections: [
        {
          key: 'cart',
          value: 'Carrinho de<br>compras',
          selected: true
        },
        {
          key: 'shipping',
          value: 'Dados da<br>entrega',
          selected: false
        },
        {
          key: 'checkout',
          value: 'Ir para o<br>checkout',
          selected: false
        }
      ]
    }
  },
  computed: {
    cart () {
      return this.$store.getters.cart
    },
    deliveryCost () {
      return this.$store.getters.storeData.delivery
        ? this.$store.getters.storeData.delivery.cost
        : 0
    },
    totalAmount () {
      return this.$store.getters.totalAmount
    },
    selectedSection () {
      return this.sections.find(element => element.selected)
    },
    title () {
      return this.selectedSection.value.replace('<br>', ' ')
    },
    shipping () {
      return this.$store.getters.shipping
    },
    hasError: {
      get () {
        return this.$store.getters.hasError
      }
    },
    showShippingAddress () {
      return this.$store.getters.showShippingAddress
    },
    environment () {
      return this.$store.getters.environment
    }
  },
  created () {
    this.updateTitles()
    document.addEventListener('keyup', this.onEsc)
  },
  beforeDestroy () {
    document.removeEventListener('keyup', this.onEsc)
  },
  methods: {
    updateTitles () {
      if (!this.showShippingAddress) {
        this.sections[1].value = 'Nome do<br>comprador'
      } else {
        this.sections[1].value = 'Dados da<br>entrega'
      }
    },
    goToState (e) {
      this.updateTitles()
      switch (e) {
        case 'cart':
          this.selectSection(e)
          this.nextState = 'shipping'
          break
        case 'shipping':
          if (
            (this.selectedSection.key === 'cart' && this.cart.length > 0) ||
            this.selectedSection.key === 'checkout'
          ) {
            this.$store.dispatch('EMPTY_ERRORS')
            this.selectSection(e)
            this.nextState = 'checkout'
          }
          break
        case 'checkout':
          if (
            this.selectedSection.key === 'shipping' ||
            (this.selectedSection.key === 'cart' && this.cart.length > 0)
          ) {
            this.$store.dispatch('VERIFY_FORM')
            if (!this.hasError) {
              this.selectSection(e)
              this.nextState = null
            }
          }
          break
        default:
      }
    },
    goNextState () {
      if (this.nextState) {
        this.goToState(this.nextState)
      } else {
        this.createCheckout()
      }
    },
    selectSection (section) {
      this.sections.forEach((element, key) => {
        if (element.key === section) {
          element.selected = true
        } else {
          element.selected = false
        }
      })
    },
    closeCart () {
      this.$emit('closeCart')
    },
    openDialog (item) {
      this.itemToRemove = item
      this.modalIsOpen = true
    },
    closeDialog () {
      this.modalIsOpen = false
    },
    updateQuantity (obj) {
      if (obj.quantity === '0' || obj.quantity === 0) {
        this.openDialog(obj.item)
      } else {
        this.$store.dispatch('UPDATE_QUANTITY_CART', {
          id: obj.item.id,
          quantity: obj.quantity
        })
      }
    },
    removeItem () {
      this.$store.dispatch('REMOVE_CART_ITEM', this.itemToRemove.id)
      this.closeDialog()
    },
    clickedOutside (e) {
      if (
        document.querySelector('#backgroundModal').contains(e.target) &&
        this.cartOpenned
      ) {
        this.$emit('closeCart')
      }
    },
    onEsc (e) {
      if (!e) e = window.event
      const keyCode = e.keyCode || e.which
      if (keyCode === 27 || keyCode === '27') {
        if (this.cartOpenned) this.$emit('closeCart')
      }
    },
    createCheckout () {
      this.creatingCheckout = true
      const storeId = this.$store.getters.storeData.id
      const body = {
        items: [],
        customer: { name: this.shipping.name.value }
      }

      this.cart.forEach(item => {
        body.items.push({ product_id: item.id, quantity: item.quantity })
      })

      if (this.showShippingAddress) {
        body.shipping_address = {}
        Object.entries(this.shipping).forEach(item => {
          if (item[0] !== 'name') {
            body.shipping_address[item[0]] = item[1].value
          }
        })
      }

      this.$store
        .dispatch('CREATE_CHECKOUT', { storeId, body })
        .then(res => {
          localStorage.removeItem(`${this.environment}cartData`)
          window.location.assign(res.checkout_url)
        })
        .catch(err => {
          this.creatingCheckout = false
          this.errors = []
          this.showAlert = true
          this.formError = true
          if (err && err.body && Array.isArray(err.body.errors)) {
            err.body.errors.forEach(error => {
              if (!this.errors.includes(error.message)) {
                this.errors.push(error.message)
              }
            })
          } else {
            this.errors.push(
              'Erro ao realizar a ação, por favor tente mais tarde.'
            )
          }
        })
    }
  },
  watch: {
    cartOpenned (newValue) {
      this.updateTitles()
    }
  }
}
</script>
